import { useAuth } from "../context/AuthContext";
import { Button } from "../components/common/Button";
import { NotifyMeForm } from "./NotifyMeForm";
import styles from "./LoginScreen.module.css";

export function LoginScreen() {
  const { login, signUp } = useAuth();
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        {/* IN DEVELOPMENT NOTICE. The dev site is publicly reachable, so
            anyone who lands here is told it is not the finished product.
            REMOVE AT LAUNCH: it is noted on #513's checklist. */}
        <p className={styles.devBanner} role="note">
          <strong>In development.</strong> This site is still being built and
          tested. Features may change or break, and data may be reset.
        </p>
        <img className={styles.logo} src="/logo-banner.png" alt="" />
        <h1 className={styles.visuallyHidden}>A Beekeepers Chronicle</h1>
        <p>Sign in to manage your hives, business, and team.</p>
        <Button onClick={login}>Sign In</Button>

        {/*
          * A ROUTE TO SIGNING UP, FROM THE SIGN-IN SCREEN (#502).
          *
          * Reported 6 Oct: "it's confusing you have to click 'SignIn' and
          * then click the 'No Account' button."
          *
          * Exactly so, and it is the worst place in the product to lose
          * somebody: account creation sat two steps behind a button
          * labelled for the opposite intent, on the first screen a new
          * user sees.
          *
          * IT NOW DEEP-LINKS (#540, verified on dev 10 Oct): Create one calls
          * signUp(), which sends prompt=create, and the tenant opens its
          * "Create account" page. The paragraph below is the history of why
          * the copy used to say otherwise.
          *
          * IT CANNOT DEEP-LINK, and the copy is written so that does not
          * matter. The tenant runs ONE combined user flow
          * (B2C_1_signupsignin), so the "Create one" control lives on
          * Microsoft's hosted page rather than here, and there is no
          * documented parameter that opens that page on its sign-up half.
          * Passing an undocumented one would be worse than this: a
          * promise that silently stops working is how #306's guidance
          * problem started.
          *
          * So this says where the control is rather than pretending to be
          * it. That still fixes the reported confusion -- somebody with
          * no account now knows this screen is for them -- without
          * claiming a behaviour we have not verified against the tenant.
          *
          * The tenant-side fix is #306's custom page templates, which is
          * where "make that page say Create Account properly" belongs.
          */}
        <p className={styles.createAccount}>
          No account yet?{" "}
          <button type="button" onClick={signUp} className={styles.createLink}>
            Create one
          </button>
        </p>
        {/* No notes under "Create one" (owner, 11 Oct): the link says it all, and
            the password rule is now shown by the tenant's own sign-in page (#306). */}
        <NotifyMeForm />
      </div>
    </div>
  );
}
